enum ControlsGameObjectState {
    Start,
    Face,
    Path,
    Power,
    Complete
}

export default ControlsGameObjectState;